module.exports = __webpack_public_path__ + "static/media/s2.b4ffec86.jpg";